import { connect } from 'react-redux';

import { hide } from 'common/actions/systemNotifications';

import SystemNotifications from '../SystemNotifications';

const mapStateToProps = ({ systemNotifications: { collection } }) => ({
  notifications: collection,
});

const mapDispatchToProps = { onHide: hide };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SystemNotifications);
